import React from 'react'
import { connect } from 'react-redux'
import { Flex, Spacer, Link, VStack } from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'
import {
  IconLogo,
  IconLogoText,
  IconDashboard,
  IconChat,
  IconHelp,
  IconRankTracker,
  IconKeywordFinder,
  IconSERPChecker,
  IconSEOChecklist,
  IconReporting,
  IconWebAudit,
  IconHowToRank,
  IconBacklinkChecker,
  IconAddon
} from '_base/Icon'
import ToggleColorMode from '_components/ToggleColorMode'
import TourToggle from './TourToggle'
import SideNavItem from './SideNavItem'
import SideNavDivider from './SideNavDivider'
import ToggleSideNav from './ToggleSideNav'

function SideNavContent({ isMobile, isExpandedSideNav }) {
  const isNormal = isMobile || isExpandedSideNav
  return (
    <Flex direction="column" h="full" bg="brand.front" color="brand.nav">
      <Link
        as={RouterLink}
        to="/"
        aria-label="Go to homepage"
        w="full"
        bg="brand.main"
        pos="sticky"
        top="0"
        zIndex="20"
      >
        <Flex w="full" h={{ base: '48px', md: '64px' }} pl="4" py="2" align="center">
          <IconLogo fontSize="32px" color="brand.logo" />
          <IconLogoText
            ml="4"
            w="105px"
            h="32px"
            color="brand.logo"
            opacity={isNormal ? 1 : 0}
            transform={isNormal ? '' : 'translateX(-50%)'}
            visibility={isNormal ? 'visible' : 'hidden'}
            transition="all, transform .175s ease, opacity .5s ease"
          />
        </Flex>
      </Link>
      <VStack pt="4" pb="2" h="full" spacing="2">
        {[
          { label: 'Dashboard', icon: IconDashboard, to: '/dashboard' },
          { label: 'Rank Tracker', icon: IconRankTracker, to: '/domains' },
          { label: 'Keyword Finder', icon: IconKeywordFinder, to: '/keyword-finder' },
          { label: 'SERP Checker', icon: IconSERPChecker, to: '/serp-checker' },
          { label: 'SEO Checklist', icon: IconSEOChecklist, to: '/seo-checklist' },
          { label: 'Reporting', icon: IconReporting, to: '/reports' },
          { label: 'Website Audit', icon: IconWebAudit, to: '/website-audit' },
          { label: 'Backlink Checker', icon: IconBacklinkChecker, to: '/backlink-checker' },
        ].map(({ label, icon, to }, index) => (
          <SideNavItem icon={icon} isNormal={isNormal} to={to} key={index} index={index}>
            {label}
          </SideNavItem>
        ))}
        <SideNavDivider />
        <SideNavItem
          type="sub"
          icon={IconHelp}
          isNormal={isNormal}
          href="https://help.ranktracker.com/en/"
          data-tour="help"
        >
          Helpdesk
        </SideNavItem>
        <SideNavItem type="sub" icon={IconAddon} isNormal={isNormal} to="/addons">
          Addons
        </SideNavItem>
        {!!window?.$crisp && (
          <SideNavItem
            type="sub"
            icon={IconChat}
            isNormal={isNormal}
            onClick={() => window.$crisp.push(['do', 'chat:open'])}
          >
            Support Chat
          </SideNavItem>
        )}
        <SideNavItem type="sub" icon={IconHowToRank} isNormal={isNormal} to="/how-to-rank">
          How to rank
        </SideNavItem>
        <Spacer />
        <TourToggle isMobile={isMobile} isNormal={isNormal} />
        <SideNavDivider />
        <Flex pos="relative" align="end" w="full" h={isNormal ? '32px' : '72px'} minH={isNormal ? '32px' : '72px'} px="4" transition="height .175s ease">
          <ToggleColorMode isNormal={isNormal} />
          <ToggleSideNav isMobile={isMobile} />
        </Flex>
      </VStack>
    </Flex>
  )
}

const mapStateToProps = state => {
  return {
    isExpandedSideNav: state.app.isExpandedSideNav
  }
}

export default connect(mapStateToProps)(SideNavContent)
